/**
 * Opacity Class
 */
export class Opacity {

	/**
	 * Constructor
	 *
	 * @param {string} containerEl
	 * @return {void}
	 */
	constructor( containerEl ) {

		this.scene = document.querySelector( containerEl );
		this.mq = window.matchMedia( '(min-width: 1200px)' );
		if ( ! this.scene ) {

			return false;

		}

		this.addEvents();

	}

	/**
	 * Add Events
	 *
	 * @return {void}
	 */
	addEvents() {

		const fxOpacityWrappers = document.querySelectorAll( '.fx-opacity' );

		// Scroll
		window.addEventListener( 'scroll', () => {

			checkOpacity();

		} );

		/**
		 * Check Opacity
		 *
		 * @return {void}
		 */
		const checkOpacity = () => {

			//const top =	 window.pageYOffset || document.documentElement.scrollTop;

			fxOpacityWrappers.forEach( ( el ) => {

				const elTop = el.getBoundingClientRect().top;

				if ( elTop <= ( window.screen.height - ( window.screen.height / 4 ) ) ) {

					el.classList.add( 'animate-opacity-in' );

				}

			} );

		}

		checkOpacity();

	}

}
